import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

import CommonSurveyAnalytics from './Common.analytics';
import ContextSurveyAnalytics from './Context.analytics';

class SurveyAnalytics extends BaseAnalytics {
    public common!: CommonSurveyAnalytics;
    public context!: ContextSurveyAnalytics;

    constructor() {
        super();

        this.common = new CommonSurveyAnalytics();
        this.context = new ContextSurveyAnalytics();
    }
}

export const surveyAnalytics = new SurveyAnalytics();

export default SurveyAnalytics;
